import GoogleRatingBadge from '@/components/reviews/GoogleRatingBadge';
import '@/components/reviews/GoogleRatingFooter.css';

export default function GoogleRatingFooter({ en = false }) {
  return <section className="google-rating-footer" aria-label={en ? 'Google store rating' : 'Butiksbedømmelse på Google'}>
    <GoogleRatingBadge en={en} compact />
  </section>;
}